import React, { useState } from "react";
import LandingPage from "./LandingPage";
import OptInMessagePage from "./OptInMessagePage";
import { parse } from "qs";
import PropTypes from "prop-types";
import { FRONTEND_ROOT } from "config/constants";
import { Helmet } from "react-helmet-async";
import ErrorBoundary from "components/Library/ErrorBoundary";

export default function Sports(props) {
  const [submitted, updateSubmitted] = useState(false);

  // Get the referral code from the query params to include on form submit
  const queryParams = parse(props.location.search.slice(1));
  const referralCode = queryParams.code || "";
  return (
    <ErrorBoundary>
      <Helmet>
        <title>Sign up for Axios Sports</title>
        <meta property="og:title" content="Sign up for Axios Sports" />
        <meta
          property="og:description"
          content="Daily insight into the news, stats and storylines dominating the sports world, by Kendall Baker"
        />
        <meta
          name="description"
          content="Daily insight into the news, stats and storylines dominating the sports world, by Kendall Baker"
        />
        <meta
          property="og:url"
          content={`${FRONTEND_ROOT}/referral/sports?code=${referralCode}`}
        />
        <meta
          property="og:image"
          content={require("assets/img/referral-sports-og.jpg")}
        />
      </Helmet>
      {submitted ? (
        <OptInMessagePage />
      ) : (
        <LandingPage
          updateSubmitted={updateSubmitted}
          referralCode={referralCode}
        />
      )}
    </ErrorBoundary>
  );
}

Sports.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
